"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
// Impede a impressão ao utilizar o atalho ctrl + p / cmd + p
var SttCtrlP = function SttCtrlP(_ref) {
  var callback = _ref.callback;
  (0, _react.useEffect)(function () {
    var SttCtrlP = function SttCtrlP(event) {
      try {
        if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
          event.preventDefault();
          callback === null || callback === void 0 ? void 0 : callback(event);
        }
      } catch (err) {
        console.error(err);
      }
    };
    document.addEventListener("keydown", SttCtrlP);
    return function () {
      document.removeEventListener("keydown", SttCtrlP);
    };
  }, [callback]);
  return null;
};
var _default = SttCtrlP;
exports["default"] = _default;